export const normalTime = (time: number, type?:string, long?: boolean) => {
    const date = new Date()
    if (time < 10000000000) {
        time = time * 1000
    }
    date.setTime(time)
    const y: any = date.getFullYear()
    let m: any = date.getMonth() + 1
    let d: any = date.getDate()

    if (d < 10) {
        d = '0' + d
    }
    if (m < 10) {
        m = '0' + m
    }
    let tor = '-'
    if (type == 'dot') {
        tor = '.'
    }
    if (type == 'slash') {
        tor = '/'
    }
    let timeString = y + tor + m + tor + d

    if (long) {
        let h: any = date.getHours()
        let m1: any = date.getMinutes()
        let s: any = date.getSeconds()
        if (h < 10) {
            h = '0' + h
        }
        if (m1 < 10) {
            m1 = '0' + m1
        }
        if (s < 10) {
            s = '0' + s
        }
        timeString = timeString + ' ' + h + ':' + m1 + ':' + s
    }

    return timeString
}

export const normalYear = (year: number) => {
    const date = new Date()
    if (year < 10000000000) {
        year = year * 1000
    }
    date.setTime(year)
    const y: any = date.getFullYear()
    return y
}

export const filterMoney = (val: any) => {
    val = val.toString().replace(/[$,]/g,'');
    if (isNaN(val)) {
        val ='0';
    }
    const sign = val == (val = Math.abs(val));
    val = Math.floor(val * 100 + 8.50000808081);
    let cents:any = val % 100;
    val = Math.floor(val / 100).toString();
    if (cents < 10) {
        cents = '0' + cents;
    }
    for (let i = 0; i < Math.floor((val.length - (1 + i)) / 3); i++) {
        val = val.substring(0, val.length - (4 * i + 3)) + ',' + val.substring(val.length - (4 * i + 3));
    }
    return (((sign) ? '' : '-') + val);
}